import Vue from 'vue'
import Router from 'vue-router'

import Signin from '@/views/acc/Signin'
import ResetPassword from '@/views/acc/ResetPassword'
import Signup from '@/views/acc/Signup'
import Signedup from '@/views/acc/Signedup'
import TermsConditions from '@/views/Terms'

import TestQuestions from '@/views/question/TestQuestions'

import Dashboard from '@/views/Dashboard'

import MyReport from '@/views/reports/MyReport'
import MyReportDetail from '@/views/reports/MyReportDetail'

import Rooms from '@/views/rooms/Rooms'
import RoomInfo from '@/views/rooms/RoomInfo'
import RoomZoneInfo from '@/views/rooms/RoomZoneInfo'
import RoomDetails from '@/views/rooms/RoomDetails'
import RoomDetailsMore from '@/views/rooms/RoomDetailsMore'

import Connections from '@/views/connections/Connections'
import ConnectionBrief from '@/views/connections/ConnectionBrief'
import ConnectionDetails from '@/views/connections/ConnectionDetails'
import Disconnect from '@/views/connections/Disconnect'

import ReportShare from '@/views/share/ReportShare'
import ConnectionShare from '@/views/share/ConnectionShare'
import ConnectionMoreShare from '@/views/share/ConnectionMoreShare'

import QRcode from '@/views/qr/QRcode'
import Landing from '@/views/Landing'

import Notifications from '@/views/more/Notifications'
import Payment from '@/views/more/Payment'

import store from '@/store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/webapp',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/webapp/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/webapp/signedup',
      name: 'Signedup',
      component: Signedup
    },
    {
      path: '/webapp/resetpassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/webapp/testquestions',
      name: 'TestQuestions',
      component: TestQuestions
    },
    {
      path: '/webapp/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/webapp/terms',
      name: 'TermsConditions',
      component: TermsConditions
    },
    {
      path: '/webapp/rooms',
      name: 'Rooms',
      component: Rooms
    },
    {
      path: '/webapp/connections',
      name: 'Connections',
      component: Connections
    },
    {
      path: '/webapp/disconnect',
      name: 'Disconnect',
      component: Disconnect
    },
    {
      path: '/webapp/report',
      name: 'MyReport',
      component: MyReport
    },
    {
      path: '/webapp/reportdetail',
      name: 'MyReportDetail',
      component: MyReportDetail
    },
    {
      path: '/webapp/connectionbrief/:connectionSeqId',
      name: 'ConnectionBrief',
      component: ConnectionBrief
    },
    {
      path: '/webapp/connectiondetails/:connectionSeqId',
      name: 'ConnectionDetails',
      component: ConnectionDetails
    },
    {
      path: '/webapp/share/report/:code',
      name: 'ReportShare',
      component: ReportShare
    },
    {
      path: '/webapp/share/connection/:code',
      name: 'ConnectionShare',
      component: ConnectionShare
    },
    {
      path: '/webapp/share/connection_more/:code',
      name: 'ConnectionMoreShare',
      component: ConnectionMoreShare
    },
    {
      path: '/webapp/qr',
      name: 'QRcode',
      component: QRcode
    },
    {
      path: '/webapp/landing/:userCode',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/webapp/roominfo/:roomSeqId',
      name: 'RoomInfo',
      component: RoomInfo
    },
    {
      path: '/webapp/roomzoneinfo',
      name: 'RoomZoneInfo',
      component: RoomZoneInfo
    },
    {
      path: '/webapp/roomdetails/:roomSeqId',
      name: 'RoomDetails',
      component: RoomDetails
    },
    {
      path: '/webapp/roomdetailsmore',
      name: 'RoomDetailsMore',
      component: RoomDetailsMore
    },
    {
      path: '/webapp/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/webapp/notifications',
      name: 'Notifications',
      component: Notifications
    }
  ]
})

router.beforeEach((to, from, next) => {
  to.matched.some((routeInfo) => {
    const path = routeInfo.path
    if (path === '/webapp/dashboard') {
      store.state.selectedMainMenu = 'dashboard'
      store.state.selectedSubMenu = ''
    } else if (path.startsWith('/webapp/room')) {
      store.state.selectedMainMenu = 'rooms'
      if (path.startsWith('/webapp/roominfo')) {
        store.state.selectedSubMenu = 'roomConnected'
      }
    } else if (path.startsWith('/webapp/connection')) {
      store.state.selectedMainMenu = 'connections'
    } else if (
      path === '/webapp/notifications' ||
      path === '/webapp/payment' ||
      path === '/webapp/terms'
    ) {
      store.state.selectedMainMenu = 'more'
      store.state.selectedSubMenu = path.substring(1)
    } else {
      store.state.selectedMainMenu = ''
    }
  })
  next()
})

export default router
